import classNames from 'classnames';
import { ChangeEvent } from 'react';

export interface TextInputProps {
  id: string;
  type: string;
  handleBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value: string;
  className?: string;
  disabled?: boolean;
  tabIndex?: number;
}

export const TextInput = ({
  id,
  type = 'text',
  handleBlur,
  handleChange,
  placeholder,
  className,
  value,
  disabled,
  tabIndex = 0,
}: TextInputProps) => {
  return (
    <input
      type={type}
      name={id}
      id={id}
      className={classNames(
        'mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md',
        className
      )}
      onBlur={handleBlur}
      onChange={handleChange}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      tabIndex={tabIndex}
    />
  );
};
